import IncidentReport from "../fragments/incidentReport";

export default `
mutation DeleteIncidentMedia($reportId: ID!, $mediaId: ID!) {
  deleteIncidentMedia(reportId: $reportId, mediaId: $mediaId) ${IncidentReport}
}
`;
